import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PlanSuspendido = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'var(--background)',
      padding: '2rem'
    }}>
      <div style={{
        background: 'var(--surface)',
        border: '1px solid var(--border)',
        borderRadius: '16px',
        padding: '3rem 2.5rem',
        maxWidth: '480px',
        width: '100%',
        textAlign: 'center',
        boxShadow: '0 8px 32px rgba(0,0,0,0.10)'
      }}>
        <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>🔒</div>
        <h1 style={{
          fontSize: '1.5rem',
          fontWeight: '700',
          color: 'var(--text-primary)',
          marginBottom: '0.75rem'
        }}>
          Plan suspendido
        </h1>
        <p style={{
          color: 'var(--text-secondary)',
          fontSize: '0.95rem',
          lineHeight: '1.6',
          marginBottom: '2rem'
        }}>
          Tu suscripción está suspendida. Para seguir usando el sistema y gestionar citas, clientes y servicios, por favor renueva tu plan.
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
          <button
            className="btn"
            style={{
              backgroundColor: 'var(--primary)',
              color: '#fff',
              justifyContent: 'center',
              fontSize: '1rem',
              padding: '0.75rem 1.5rem'
            }}
            onClick={() => navigate('/suscripcion/pagar')}
          >
            Renovar suscripción
          </button>
          <button
            className="btn"
            style={{
              backgroundColor: 'transparent',
              color: 'var(--text-secondary)',
              border: '1px solid var(--border)',
              justifyContent: 'center'
            }}
            onClick={() => navigate('/')}
          >
            Ver dashboard
          </button>
          <button
            className="btn"
            style={{
              backgroundColor: 'transparent',
              color: 'var(--error)',
              border: 'none',
              justifyContent: 'center',
              fontWeight: '400',
              fontSize: '0.875rem'
            }}
            onClick={logout}
          >
            Cerrar sesión
          </button>
        </div>
      </div>
    </div>
  );
};

export default PlanSuspendido;
